__turbopack_context__.v({
  "emailInput": "Newsletter-module__AfgrAq__emailInput",
  "errorMessage": "Newsletter-module__AfgrAq__errorMessage",
  "fadeIn": "Newsletter-module__AfgrAq__fadeIn",
  "inputWrapper": "Newsletter-module__AfgrAq__inputWrapper",
  "newsletter": "Newsletter-module__AfgrAq__newsletter",
  "newsletterContainer": "Newsletter-module__AfgrAq__newsletterContainer",
  "newsletterContent": "Newsletter-module__AfgrAq__newsletterContent",
  "newsletterForm": "Newsletter-module__AfgrAq__newsletterForm",
  "newsletterHeader": "Newsletter-module__AfgrAq__newsletterHeader",
  "statusMessage": "Newsletter-module__AfgrAq__statusMessage",
  "submitButton": "Newsletter-module__AfgrAq__submitButton",
  "successMessage": "Newsletter-module__AfgrAq__successMessage",
});
